export default __webpack_public_path__ + "static/media/sleepy.975c4349.svg";